module.exports = __webpack_public_path__ + "img/seven.7fd3dc14.png";